import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "Login 3 Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M20.25 18.75v1.5a1.5 1.5 0 0 1-1.5 1.5h-4.5M14.25 3.75h4.5a1.5 1.5 0 0 1 1.5 1.5v1.5M10.39 23.24l-9-1.24a.75.75 0 0 1-.64-.75V3.72A.75.75 0 0 1 1.34 3l9-2.22a.75.75 0 0 1 .91.73v21a.74.74 0 0 1-.86.73M18 9.75l-3 3h8.25M18 15.75l-3-3"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-width": "1.5",
      d: "M7.375 12.381a.375.375 0 1 1 0-.75M7.375 12.381a.375.375 0 1 0 0-.75"
    }, null, -1)
  ]))]))
}
export default { render: render }